import { useQuery } from '@hooks/core';
import api from './api';

export const useBasicFee = () => useQuery(api.getBasicSMFee);

export const useCoinInfo = () => useQuery(api.getCoinInfo, { initial: { assets: [], fees: [] } });
